const LinkIcon = ({ width = 24, height = 24, className = '' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 28 28'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <g clipPath='url(#clip0_15211_21284)'>
                <path
                    d='M25.4539 2.54628C23.9112 1.00739 21.8204 0.142578 19.6416 0.142578C17.4618 0.142578 15.371 1.00739 13.8284 2.54628L10.3476 6.02707C9.84141 6.53579 9.84268 7.35863 10.3501 7.86609C10.8576 8.37354 11.6804 8.37481 12.1892 7.8699L15.6699 4.38911C16.723 3.33478 18.1512 2.74212 19.6417 2.74085C21.1323 2.74085 22.5618 3.33224 23.6148 4.3853C24.6691 5.43963 25.2605 6.86913 25.2605 8.35837C25.2592 9.84891 24.6666 11.2771 23.6122 12.3314L20.1314 15.8122C19.8873 16.0564 19.7499 16.3871 19.7499 16.733C19.7499 17.0789 19.8873 17.4096 20.1314 17.6538C20.3756 17.898 20.7063 18.0353 21.0522 18.0353C21.3982 18.0353 21.7288 17.898 21.973 17.6538L25.4538 14.173C26.9978 12.6316 27.8638 10.5408 27.8638 8.35974C27.8638 6.17867 26.9979 4.08758 25.4539 2.54628Z'
                    fill='#1A1A1B'
                />
                <path
                    d='M15.8122 20.1316L12.3314 23.6124C11.2784 24.6668 9.85013 25.2594 8.35965 25.2594C6.87038 25.2594 5.44088 24.668 4.38658 23.615C3.33352 22.5606 2.74214 21.1311 2.74214 19.6419C2.74214 18.1514 3.33479 16.7231 4.38912 15.6701L7.86991 12.188C8.37609 11.6793 8.37482 10.8577 7.86737 10.3503C7.35992 9.84284 6.53835 9.84157 6.02835 10.3465L2.54756 13.8273C0.471983 15.9054 -0.339431 18.9311 0.421127 21.7685C1.18165 24.6046 3.39714 26.8202 6.23341 27.5808C9.07078 28.3401 12.0965 27.5299 14.1734 25.4544L17.6541 21.9736C17.8996 21.7294 18.037 21.3975 18.037 21.0528C18.037 20.7069 17.8996 20.3749 17.6554 20.1308C17.4112 19.8866 17.0793 19.7492 16.7346 19.7492C16.3887 19.7492 16.0568 19.8866 15.8126 20.132L15.8122 20.1316Z'
                    fill='#1A1A1B'
                />
                <path
                    d='M7.98311 20.0124C8.49183 20.5211 9.31725 20.5211 9.82466 20.0124L20.0079 9.83052C20.5153 9.3218 20.5153 8.49765 20.0079 7.98896C19.4992 7.48024 18.675 7.48024 18.1663 7.98896L7.98311 18.1709C7.73893 18.4151 7.60156 18.747 7.60156 19.0916C7.60156 19.4376 7.73892 19.7682 7.98311 20.0124Z'
                    fill='#1A1A1B'
                />
            </g>
            <defs>
                <clipPath id='clip0_15211_21284'>
                    <rect width='28' height='28' fill='white' />
                </clipPath>
            </defs>
        </svg>
    );
};

export default LinkIcon;
